import { Form } from "formsy-semantic-ui-react"
import qs from "query-string"
import React, { Component } from "react"
import { Button, Label } from "semantic-ui-react"
import {
  checkResetPasswordToken,
  postChangePassword
} from "../api/async/users/index"
import { setUserAndToken } from "../api/utils"

class ChangePassword extends Component {
  state = { isValid: true }
  componentDidMount = async () => {
    const query = qs.parse(this.props.history.location.search)
    this.setState({ token: query.token })
    checkResetPasswordToken(query.token).catch(e =>
      this.setState({ isValid: false })
    )
    document.title = "Run24Hrs - เปลี่ยนรหัสผ่าน"
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = () => {
    postChangePassword(this.state.token, this.state.password).then(res => {
      if (res.status === 200) {
        setUserAndToken(res.data.username, res.data.token)
        this.props.history.push("/")
        setTimeout(() => {
          window.location.reload()
        }, 500)
      }
    })
  }

  render() {
    const errorLabel = <Label color="red" pointing />
    return this.state.isValid ? (
      <React.Fragment>
        <h1>เปลี่ยนรหัสผ่าน</h1>
        <Form
          style={{ marginBottom: "10px" }}
          onValidSubmit={this.handleSubmit}
        >
          <Form.Group>
            <Form.Input
              style={{ width: 220 }}
              required
              validationErrors={{
                isDefaultRequiredValue: "โปรดกรอกรหัสผ่าน"
              }}
              name="password"
              type="password"
              placeholder="โปรดกรอกรหัสผ่าน"
              onChange={this.handleChange}
              errorLabel={errorLabel}
            />
          </Form.Group>
          <Form.Group>
            <Form.Input
              style={{ width: 220 }}
              required
              validations="equalsField:password"
              validationErrors={{
                isDefaultRequiredValue: "โปรดกรอกรหัสผ่านอีกครั้ง",
                equalsField: "โปรดกรอกรหัสผ่านให้ตรงกัน"
              }}
              type="password"
              name="confirm_password"
              placeholder="โปรดกรอกรหัสผ่านอีกครั้ง"
              onChange={this.handleChange}
              errorLabel={errorLabel}
            />
          </Form.Group>
          <Button className="ui teal mt10" type="submit">
            เปลี่ยนรหัสผ่าน
          </Button>
        </Form>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <h3>เกิดข้อผิดพลาด</h3>
      </React.Fragment>
    )
  }
}

export default ChangePassword



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/ChangePassword.js